import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid, Box } from '@mui/material';
import { usePublicSettings } from '../../hooks/usePublicSettings';
import EventGalleryImage from './EventGalleryImage';

interface EventGalleryProps {
    images: { signedUrl: string }[];
}

const EventGallery: React.FC<EventGalleryProps> = ({ images }) => {
    const [hasImageLoadError, setHasImageLoadError] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { logoUrl } = usePublicSettings();
    const logoBucketUrl = import.meta.env.VITE_LOGO_BUCKET_URL;
    const errorSource = logoBucketUrl + logoUrl;

    if (!images || images.length === 0) {
        return <></>;
    }

    const displayImages = isMobile ? images.slice(0, 1) : images.slice(0, 5);

    return (
        <Grid container spacing={1} mb={3}>
            {isMobile ? (
                <Grid item xs={12}>
                    <Box
                        component="img"
                        src={displayImages[0].signedUrl}
                        onError={hasImageLoadError ? undefined : ({currentTarget}) => {
                            currentTarget.src = logoBucketUrl + logoUrl;
                            setHasImageLoadError(true);
                        }}
                        alt="Event image 1"
                        loading="eager"
                        sx={{ width: '100%', height: 200, objectFit: 'contain' }}
                    />
                </Grid>
            ) : (
                <>
                    <Grid item xs={6}>
                        <Box
                            component="img"
                            src={displayImages[0].signedUrl}
                            onError={hasImageLoadError ? undefined : ({currentTarget}) => {
                                currentTarget.src = logoBucketUrl + logoUrl;
                                setHasImageLoadError(true);
                            }}
                            alt="Event image 1"
                            loading="eager"
                            sx={{ width: '100%', height: 290, objectFit: 'contain' }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container spacing={1}>
                            {displayImages.slice(1).map((img, index) => (
                                <Grid item xs={6} key={index}>
                                    <EventGalleryImage source={img.signedUrl} key={String(index+2)} errorSource={errorSource} />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default EventGallery;